(function(){
'use strict';

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

/* Program Designation */
angular.module('classy').component('egProgramDesignation', {
  templateUrl: 'global/embedded-giving/components/program-designation/eg.components.program-designation', // same folder as this
  bindings: {
    parentModel: '='
  },
  controller: ["scCampaignsService", "designationsService", "$log", "EmbeddedGivingPaths", "EmbeddedGiving", "$timeout", "$scope", "$element", function controller(scCampaignsService, designationsService, $log, EmbeddedGivingPaths, EmbeddedGiving, $timeout, $scope, $element) {
    var _this = this;

    this.campaign = scCampaignsService.active.current;
    this.showGroupLabels = this.campaign.display_group_name;
    this.sort = designationsService.parseSortOrder(this.campaign.sort_designation_by);
    this.page = 1;
    this.maxPage = false;

    this.designations = {};
    this.uiItems = [];

    this.getCampaignDesignationItems = function (filter) {
      return designationsService.getGroupedCampaignDesignations(_this.campaign.id, {
        filter: filter,
        per_page: 100,
        page: _this.page,
        sort: _this.sort
      }).then(function (groups) {
        return _this.buildDesignationsByGroup(groups);
      });
    };

    this.toggleIcon = EmbeddedGivingPaths.images.designation;

    this.buildDesignationsByGroup = function (groups) {
      var designationsByGroup = {};

      // Only show group labels if the appropriate campaign setting is enabled
      groups.forEach(function (group) {
        // Only add the header if group.designations is not empty
        if (group.designations.length > 0) {
          designationsByGroup[group.name] = group.designations;
        }
      });

      return designationsByGroup;
    };

    this.addDesignationsByGroup = function (designationsByGroup) {
      Object.keys(designationsByGroup).forEach(function (groupName) {
        var designations = designationsByGroup[groupName];

        if (!_this.designations[groupName]) {
          _this.designations[groupName] = [];
        }

        _this.designations[groupName] = _.union(_this.designations[groupName], designations);
        _this.designations[groupName] = _.uniqBy(_this.designations[groupName], 'id');
      });
    };

    this.buildUIItems = function () {
      var uiItems = [];

      Object.keys(_this.designations).forEach(function (groupName) {
        uiItems.push({
          isGroupLabel: true,
          label: groupName
        });

        uiItems = _.union(uiItems, _this.designations[groupName]);
      });

      _this.uiItems = uiItems;
    };

    this.searchTerm = '';
    /**
     * The "Program designations" feature has to be enabled and
     * there must be at least 2 designations to show the program designation picker
     */
    this.isEnabled = scCampaignsService.active.DESIGNATIONS_ENABLED && scCampaignsService.active.current.designations_count > 1;
    this.isLoading = false;
    this.isOpen = false;

    this.$onInit = function () {
      $timeout(function () {
        _this.parentModel = _this.parentModel || {};

        var element = document.getElementById('designations-drawer');

        element.addEventListener('scroll', _this.onScroll, true);

        if (_this.parentModel && _this.parentModel.designation) {
          _this.designationId = _this.parentModel.designation_id;
        } else {
          _this.designationId = EmbeddedGiving.opts.default.designation;
        }

        if (!_this.designationId) {
          _this.designation = Object.assign({}, _this.campaign.designation) || null;
        } else {
          _this.designation = null;
        }

        __loadDesignations();
      });
    };

    this.toggleLoading = function () {
      $timeout(function () {
        _this.isLoading = !_this.isLoading;
      });
    };

    this.setDesignation = function (designation) {
      if (!designation) {
        return;
      }

      $timeout(function () {
        _this.designation = designation;
        _this.parentModel.designation = designation;
        _this.parentModel.designation_id = designation.id;
      });
    };

    this.onSearch = function (designation) {
      return !designation.hidden;
    };

    this.onClearSearch = function () {
      _this.reset();
      _this.searchTerm = '';

      __loadDesignations();
    };

    this.hasSearchResults = function () {
      return !_.isEmpty(_this.designations);
    };

    this.onOpen = function () {
      _this.reset();
      _this.isOpen = true;

      __loadDesignations();
    };

    this.onClose = function () {
      _this.searchTerm = '';
      _this.reset();
      _this.isOpen = false;
    };

    this.onSelect = function (designation) {
      if (designation && designation.id) {
        _this.setDesignation(designation);
      }

      _this.onClose();
    };

    this.onScroll = function (event) {
      var element = event.target;

      var scrollTop = element.scrollTop;
      var scrollHeight = element.scrollHeight;
      var clientHeight = element.clientHeight;

      // Calculate the ratio of how close to the end the scrollbar is
      var scrollRatio = scrollTop / (scrollHeight - clientHeight);

      if (scrollRatio > 0.9) {
        __debouncedScroll();
      }
    };

    var __debouncedScroll = _.debounce(function () {
      _this.page += 1;
      __loadDesignations();
    }, 250);

    this.reset = function () {
      _this.designations = {};
      _this.uiItems = [];
      _this.page = 1;
      _this.maxPage = false;
    };

    var __debouncedLoadDesignations = _.debounce(function () {
      return __loadDesignations();
    }, 1000);

    var __loadDesignations = function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var searchTerm, filter, designations, designation;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!_this.maxPage) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt('return');

              case 2:
                searchTerm = _this.searchTerm.toLowerCase();


                if (_this.page === 1) _this.toggleLoading();

                _context.prev = 4;
                filter = 'is_active=true';


                if (searchTerm) {
                  filter += ',name*=' + searchTerm;
                } else if (_this.designationId && !_this.isOpen) {
                  filter += ',id=' + _this.designationId;
                }

                _context.next = 9;
                return _this.getCampaignDesignationItems(filter);

              case 9:
                designations = _context.sent;


                if (_.isEmpty(designations)) _this.maxPage = true;

                _this.addDesignationsByGroup(designations);
                _this.buildUIItems();

                if (!searchTerm && _this.designationId && !_this.designation) {
                  // Get the first designation in the first group
                  designation = designations[Object.keys(designations)[0]][0];


                  _this.setDesignation(designation);
                }

                // This will force the view to update
                $timeout(function () {});
                _context.next = 20;
                break;

              case 17:
                _context.prev = 17;
                _context.t0 = _context['catch'](4);

                $log.error('Unable to fetch designations', _context.t0);

              case 20:
                _context.prev = 20;

                if (_this.page === 1) _this.toggleLoading();
                return _context.finish(20);

              case 23:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[4, 17, 20, 23]]);
      }));

      return function __loadDesignations() {
        return _ref.apply(this, arguments);
      };
    }();

    $scope.$watch(function () {
      return _this.searchTerm;
    }, function (newValue, oldValue) {
      if (newValue === oldValue) return;

      _this.reset();
      __debouncedLoadDesignations();
    });

    $scope.$watch(function () {
      return _this.isLoading;
    }, function (newValue) {
      var inputElement = $element.find('#searchInputEG');

      if (newValue) {
        // Disable the input
        inputElement.attr('disabled', 'disabled');
      }

      if (!newValue) {
        // Enable the input
        inputElement.removeAttr('disabled');

        // Focus it so the user can continue typing
        inputElement[0].focus(); // Focus on the input element
      }
    });
  }]
});
})();